import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Spinners from "components/Common/Spinner";

import { ToastContainer } from "react-toastify";
import Config from "config";
const NewTicket = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [wait, setWait] = useState(0);

  const [userData, setUserData] = useState([]);

  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  //Pièce jointe
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  // Hashtag #
  const [selectedHashTag, setSelectedHashTag] = useState("");
  // Titre de la requete
  const [selectedTitreRequete, setSelectedTitreRequete] = useState("");
  const handleTitreRequeteChange = (event) => {
    setSelectedTitreRequete(event.target.value);
  };
  // Type de la requete
  const [selectedTypeRequete, setSelectedTypeRequete] = useState("");
  const [typeRequeteData, setTypeData] = useState({ data: [] });
  const [selectedRoleAccount, setSelectedRoleAccount] = useState("");
  const handleselectedRoleAccountChange = (event) => {
    setSelectedRoleAccount(event.target.value);
  };
  const handleTypeRequeteChange = (event) => {
    setSelectedTypeRequete(event);
  };
  const getTypeRequete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_ticket_types`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTypeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeRequeteOptions = () => {
    return [
      {
        options: typeRequeteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Description
  const [selectedDescription, setSelectedDescription] = useState("");
  const handleDescriptionChange = (event) => {
    setSelectedDescription(event.target.value);
  };
  // Url
  const [selectedUrl, setSelectedUrl] = useState("");
  const handleUrlChange = (event) => {
    setSelectedUrl(event.target.value);
  };
  // Criticite
  const [selectedCriticite, setSelectedCriticite] = useState("");
  const [criticiteData, setCriticiteData] = useState({ data: [] });
  const handleCriticiteChange = (event) => {
    setSelectedCriticite(event);
  };
  const getCriticite = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/criticities`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCriticiteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCriticiteOptions = () => {
    return [
      {
        options: criticiteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Compte
  const [selectedCompte, setSelectedCompte] = useState("");
  const [compteData, setCompteData] = useState({ data: [] });
  const handleCompteChange = (event) => {
    setSelectedCompte(event);
  };
  const getCompte = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_users`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCompteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCompteOptions = () => {
    return [
      {
        options: compteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Commentaire
  const [selectedCommentaire, setSelectedCommentaire] = useState("");
  const handleCommentaireChange = (event) => {
    setSelectedCommentaire(event.target.value);
  };
  // Budget
  const [selectedBudget, setSelectedBudget] = useState("");
  const handleBudgetChange = (event) => {
    setSelectedBudget(event.target.value);
  };
  // StatutLiv
  const [selectedStatutLiv, setSelectedStatutLiv] = useState("");
  const [statutLivData, setSelectedStatutLivData] = useState({ data: [] });
  const handleStatutLivChange = (event) => {
    setSelectedStatutLiv(event);
  };
  const getStatutLiv = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/delivery_status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedStatutLivData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutLivOptions = () => {
    return [
      {
        options: statutLivData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // StatutReq
  const [selectedStatutReq, setSelectedStatutReq] = useState({
    label: "En cours",
    id: 1,
  });
  const [statutReqData, setSelectedStatutReqData] = useState({ data: [] });
  const handleStatutReqChange = (event) => {
    setSelectedStatutReq(event);
  };
  const getStatutRequete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_ticket_status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedStatutReqData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutReqOptions = () => {
    return [
      {
        options: statutReqData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Temps
  const [selectedTemps, setSelectedTemps] = useState("");
  const handleTempsChange = (event) => {
    setSelectedTemps(event.target.value);
  };
  // DateLiv
  const [selectedDateLiv, setSelectedDateLiv] = useState("");
  // DateCorr
  const [selectedDateCorr, setSelectedDateCorr] = useState("");

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Tickets | EDIT";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails Ticket"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedTitreRequete === "" ||
      selectedDescription === "" ||
      selectedTypeRequete === null ||
      selectedCriticite === null ||
      selectedUrl === "" ||
      (selectedCompte === "" && type_compte == "builder")
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        setLoading(true);

        const formData = new FormData();

        formData.append("name", selectedTitreRequete);
        formData.append("fx_ticket_type_id", selectedTypeRequete?.value);
        formData.append("criticity", selectedCriticite?.value);
        formData.append("url", selectedUrl);
        formData.append("description", selectedDescription);
        //formData.append("fx_ticket_status_id", selectedStatutReq);
        formData.append("commentaires_support", selectedCommentaire);
        type_compte == "builder"
          ? formData.append("fx_user_id", selectedCompte?.value)
          : null;
        formData.append("fichier", selectedFichier);
        formData.append("role_or_account_used", selectedRoleAccount);
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("POSt request successful");
          const responseData = await response.json();
          navigate(`${backUrl}/fx_tickets/${responseData.id}`);
        } else {
          console.error("POST request failed");
          const responseData = await response.json();

          if (responseData && responseData.fx_ticket_validation) {
            const errors = responseData?.fx_ticket_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        await getTypeRequete();
        await getStatutRequete();
        await getCompte();
        await getCriticite();
        await getStatutLiv();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row className="mb-2">
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/fx_tickets/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Tickets
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        userData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleSubmit}
                      >
                        <i className="bx bx-send"></i> Valider
                      </button>
                      &nbsp; &nbsp;
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        className="btn btn-sm btn-soft-secondary "
                        style={{ width: "88.43px" }}
                      >
                        <i className="bx bx-arrow-back"></i> Annuler
                      </Link>
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row className="mb-2">
                            <Col sm="12">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  {" "}
                                  Requête
                                </CardTitle>
                                <CardBody>
                                  <Row className="mb-3">
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Titre de la requête*:</span>
                                        </i>
                                      </Col>
                                      <Col className=" col-md-8">
                                        <input
                                          className="form-control form-control-sm"
                                          type="text"
                                          value={selectedTitreRequete}
                                          required
                                          onChange={handleTitreRequeteChange}
                                        />
                                        {selectedTitreRequete === "" ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Titre de la requête ne peut pas être
                                            vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Type de requête* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-8">
                                        <Select
                                          defaultValue={selectedTypeRequete}
                                          onChange={handleTypeRequeteChange}
                                          options={renderTypeRequeteOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedTypeRequete === null ||
                                              selectedTypeRequete == ""
                                          )}
                                        />
                                        {selectedTypeRequete === null ||
                                        selectedTypeRequete == "" ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Type de la requête ne peut pas être
                                            vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Compte utilisé :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-8">
                                        <input
                                          type="text"
                                          defaultValue={selectedRoleAccount}
                                          onChange={
                                            handleselectedRoleAccountChange
                                          }
                                          className="form-control form-control-sm"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>URL du bug* :</span>
                                        </i>
                                      </Col>
                                      <Col className=" col-md-8">
                                        <input
                                          type="text"
                                          defaultValue={selectedUrl}
                                          onChange={handleUrlChange}
                                          className="form-control form-control-sm"
                                        />
                                        {selectedUrl === "" ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Url ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Description* :</span>
                                        </i>
                                      </Col>
                                      <Col className=" col-md-8">
                                        <textarea
                                          type="text"
                                          rows="5"
                                          defaultValue={selectedDescription}
                                          onChange={handleDescriptionChange}
                                          className="form-control form-control-sm"
                                        />
                                        {selectedDescription === "" ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Description ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Pièce jointe :</span>
                                        </i>
                                      </Col>
                                      <Col className=" col-md-8">
                                        <input
                                          type="file"
                                          onChange={handleFichierChange}
                                          className="form-control form-control-sm"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Criticité* :</span>
                                        </i>
                                      </Col>
                                      <Col className=" col-md-8">
                                        <Select
                                          defaultValue={selectedCriticite}
                                          onChange={handleCriticiteChange}
                                          options={renderCriticiteOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedCriticite === null ||
                                              selectedCriticite == ""
                                          )}
                                        />
                                        {selectedCriticite === null ||
                                        selectedCriticite == "" ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Criticité ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>

                            <Row className="mb-2">
                              <Col sm="12">
                                {" "}
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Suivi
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      <Row className="mb-2">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span>Statut de la requête :</span>
                                          </i>
                                        </Col>
                                        <Col className="col-md-8">
                                          <Select
                                            defaultValue={selectedStatutReq}
                                            onChange={handleStatutReqChange}
                                            options={renderStatutReqOptions()}
                                            isClearable={true}
                                            className="select2"
                                            isDisabled
                                          />
                                        </Col>
                                      </Row>
                                      {type_compte == "builder" ? (
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Crée par* :</span>
                                            </i>
                                          </Col>
                                          <Col className=" col-md-8">
                                            <Select
                                              defaultValue={selectedCompte}
                                              onChange={handleCompteChange}
                                              options={renderCompteOptions()}
                                              isClearable={true}
                                              className="select2"
                                              styles={styles(
                                                selectedCompte === null ||
                                                  selectedCompte == ""
                                              )}
                                            />
                                            {selectedCompte === null ||
                                            selectedCompte == "" ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Crée par ne peut pas être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </Row>
                                      ) : null}
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default NewTicket;
